import script from "./CallTranscriptViewerDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CallTranscriptViewerDialog.vue?vue&type=script&setup=true&lang=js"

import "./CallTranscriptViewerDialog.vue?vue&type=style&index=0&id=7f4e1127&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f4e1127"]])

export default __exports__